import { TenantBranding } from './tenant-branding';
import { TenantIntegration } from './tenantIntegration';
import { TenantPlan } from './tenantPlan';
import { TenantModule } from './tenantModule';
import { AdminPortalModel } from 'src/app/admin/admin-home/admin-portal/admin-portal-model';
import { TenantPlatformLanguage } from './tenant-platform-language';
import { TenantSystemSettings } from './tenant-system-settings';

export class Tenant {
  constructor(
    public id: string,
    public name: string,
    public defaultConnection: string,
    /** Full UI base URL, including scheme and trailing slash */
    public baseWebUrl: string,
    public connections: string[],
    public logoUrl: string,
    public administrator: string,
    public administratorEmail: string,
    public bccAdministrator: boolean,
    public fromEmail: string,
    public manageRolesInLineup: boolean,
    public integrations: TenantIntegration[],
    public modules: TenantModule[],
    public plan: TenantPlan,
    public timeZone: string,
    public tenantHelpLink: string,
    public allowPortalUserCreation: boolean,
    public portalConfiguration: AdminPortalModel,
    public subdomain: string,
    /** Uri to portal including scheme and trailing slash */
    public portalUri: string,
    /** Uri to identity server including scheme and trailing slash */
    public portalLoginUri: string,
    public branding: TenantBranding,
    public platformLanguage: TenantPlatformLanguage,
    public settings: TenantSystemSettings
  ) {
    this.usesCertifications = !!this.integrations.find((i) => i.providesCertifications);
  }
  public usesCertifications: boolean;

  getInvitationLink = (personId: string, seatId: string) =>
    `${this.baseWebUrl}members/${personId}/seat/${seatId}`;

  getOpportunityListingLink = (listingId: string) => `${this.baseWebUrl}opportunities/${listingId}`;

  static parse(
    obj: Partial<Tenant> & {
      tenantModules?: TenantModule[];
      systemFieldVisibility?: TenantSystemSettings;
    }
  ): Tenant {
    if (!obj) return;
    return new Tenant(
      obj.id,
      obj.name,
      obj.defaultConnection,
      obj.baseWebUrl,
      obj.connections,
      obj.logoUrl,
      obj.administrator,
      obj.administratorEmail,
      obj.bccAdministrator,
      obj.fromEmail,
      obj.manageRolesInLineup,
      obj.integrations?.length
        ? obj.integrations.map((integration) => TenantIntegration.parse(integration))
        : [],
      obj.tenantModules?.length ? obj.tenantModules : [],
      obj.plan ? new TenantPlan(obj.plan) : null,
      obj.timeZone,
      obj.tenantHelpLink,
      obj.allowPortalUserCreation,
      obj.portalConfiguration,
      obj.subdomain,
      obj.portalUri,
      obj.portalLoginUri,
      TenantBranding.parse(obj.branding),
      TenantPlatformLanguage.parse(obj.platformLanguage),
      TenantSystemSettings.parse(obj.settings ?? obj.systemFieldVisibility)
    );
  }
}
